import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'
import { chatStore } from './chatStore'

type Store = {
  isOpen: boolean
  toggleSidebar: () => void
  closeSidebar: () => void
}

export const sidebarStore = create<Store>((set) => ({
  isOpen: JSON.parse(localStorage.getItem('sidebarIsOpen') ?? 'false'),
  toggleSidebar: () =>
    set((state) => {
      const newState = !state.isOpen
      localStorage.setItem('sidebarIsOpen', JSON.stringify(newState))
      // Close chat when opening sidebar
      if (newState) {
        chatStore.getState().closeChat()
      }
      return { isOpen: newState }
    }),
  closeSidebar: () =>
    set(() => {
      const newState = false
      localStorage.setItem('sidebarIsOpen', JSON.stringify(newState))
      return { isOpen: newState }
    }),
}))

export const useSidebarStore = () => {
  return sidebarStore(useShallow((s) => s))
}
